var styles = {"hide-alt-text-while-loading":"styles_hide-alt-text-while-loading__15o8u","hideAltTextWhileLoading":"styles_hide-alt-text-while-loading__15o8u"};

export default styles;
//# sourceMappingURL=styles.css.js.map
